import styled from 'styled-components';

interface ICardButtonProps
{
    theme?: any;
    selected: boolean;
    anyselected: number;
    readOnly?: boolean;
}

export const Container = styled.div`
    display: flex;
    justify-content: flex-start;
    overflow-x: hidden !important;
    padding-bottom: 10px;
    padding-right: 5px;

    @media(max-width: 1279px)
    {
        flex-wrap: wrap;
        overflow-x: hidden;
        gap: 2px;
    }
`;

export const CardButton = styled.button<ICardButtonProps>`
    background: none;
    border: none;
    cursor: ${(props) => (props.readOnly ? 'default' : 'pointer')};
    border-radius: 16px;
    flex: 0 0 calc(100% / 13);
    padding: 2.5px;
    img
    {
        max-width: 100%;
        opacity: ${(props) => (props.anyselected ? '0.5' : '1')};
        border: 2px solid transparent;
        border-radius: 16px;
        padding: 2px;
        ${(props) => props.selected &&
        {
            border: `2px solid ${props.theme.palette.themePrimary}`,
            opacity: '1',
        }}
    }

    @media(max-width: 1279px)
    {
        flex: 0 0 calc((100% - 20px) / 6);
        max-width: calc((100% - 20px) / 6);
    }

    @media(max-width: 768px)
    {
        flex: 0 0 calc((100% - 15px) / 4);
        max-width: calc((100% - 15px) / 4);
    }
`;